import CheckoutConfig from '@/../PaymentIQCheckoutClientConfig'
import Store from '@/store'
import { get, post, patch } from './'
import { LookupUser, DidUserdata, CheckDeviceId } from './ApiResponseTypes'

const buildUrl = (path: string) => {
  const { DID_API_PATH } = CheckoutConfig[Store.state.context.config.environment]
  return `${DID_API_PATH}/${path}`
}
const buildPiqUrl = (path: string) => {
  const { PIQ_API_PATH } = CheckoutConfig[Store.state.context.config.environment]
  return `${PIQ_API_PATH}/${path}`
}

export const Api = {
  // fetch translations from PIQ (defined in PaymentIQ Backoffice)
  getTranslations (locale: string, merchantId: string) {
    return get(buildPiqUrl(`resource/translations?locale=${locale}&merchantId=${merchantId}`), {}, {})
  },
  checkDeviceId (deviceId: string | null): CheckDeviceId {
    const DID_CLIENT_ID = Store.state.context.config.didClientId
    return get(buildUrl(`api/ip/device/check?client_id=${DID_CLIENT_ID}&device_id=${deviceId}`), {}, {})
  },
  getDidUserLookup (didAccessToken: string): Promise<any> {
    return get(buildUrl(`api/oauth/userinfo`), {}, { Authorization: `Bearer ${didAccessToken}` })
  },
  updateDidUser (didAccessToken: string, userData: DidUserdata): Promise<any> {
    return patch(buildUrl(`api/oauth/userinfo`), userData, {}, { Authorization: `Bearer ${didAccessToken}` })
  },
  getDidUserInfo (payload: URLSearchParams): Promise<any> {
    return post(buildUrl(`api/oauth/token`), payload)
  },
  lookupExistingDidUser (source: string, identifyProvider: string | null, deviceId: string, data: string, country: string): Promise<any> {
    const { DID_REDIRECT_URI } = CheckoutConfig[Store.state.context.config.environment]
    const DID_CLIENT_ID = Store.state.context.config.didClientId
    let endpoint = `api/oauth/auth?identity_provider=${identifyProvider}&device_id=${deviceId}&redirect_method=postmessage&client_id=${DID_CLIENT_ID}&redirect_uri=${encodeURIComponent(DID_REDIRECT_URI)}&response_type=code&scope=openid&state=123456789123`
    endpoint += data
    return get(buildUrl(endpoint), {}, {})
  }
}
